import styled from "styled-components";
import { Link } from "react-router-dom";
import { COLORS } from "shared/consts";
import { toEm, toRem } from "shared/helpers";

export const DashboardWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr;
  /* grid-template-rows: ${toRem(230)} ${toRem(230)} ${toRem(200)} ${toRem(
    200
  )} ${toRem(104)} ${toRem(50)}; */
  grid-template-rows: ${toRem(148)} ${toRem(148)} ${toRem(148)} ${toRem(
      200
    )} ${toRem(200)} ${toRem(104)} ${toRem(50)};
  padding-bottom: ${toRem(20)};

  gap: ${toRem(16)};
  max-width: ${toRem(2000)};

  grid-template-areas:
    "weather state     state     notification"
    "weather state     state     notification"
    "weather state     state     calendar"
    "weather temp      co2       calendar"
    "weather humidity  weight    sound"
    "weather pesticide pesticide sound"
    "archive archive archive archive";

  @media screen and (max-width: ${toEm(1500)}) {
    grid-template-columns: 2fr 1fr 1fr;
    grid-template-rows: ${toRem(470)} ${toRem(200)} ${toRem(200)} ${toRem(
        154
      )} ${toRem(186)} ${toRem(186)} ${toRem(50)};

    grid-template-areas:
      "weather state     state"
      "weather temp      co2"
      "weather humidity  weight"
      "notification pesticide pesticide"
      "notification calendar calendar"
      "sound calendar calendar"
      "archive archive archive";
  }

  @media screen and (max-width: ${toEm(1000)}) {
    display: flex;
    flex-direction: column;
    padding-bottom: ${toRem(50)};
  }
`;

export const DashboardArea = styled.div<{ $area: string }>`
  grid-area: ${({ $area }) => $area};

  min-width: 0;
  min-height: 0;

  border-radius: ${toRem(16)};
  background: ${COLORS.BG.SURFACE1};

  ${({ $area }) => $area == "notification" && "padding: 24px;"}

  .happiness {
    height: max-content;
  }
`;

export const PesticideMapSection = styled(Link)`
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-radius: ${toRem(16)};
  max-height: ${toRem(154)};
`;

export const PesticideMapIcon = styled.div`
  margin-right: ${toRem(8)};
  padding-left: ${toRem(16)};
  padding-top: ${toRem(16)};
  padding-bottom: ${toRem(16)};
`;

export const PesticideMapCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(2)};
  margin-right: ${toRem(24)};
  padding-top: ${toRem(16)};
  padding-bottom: ${toRem(16)};
  min-width: ${toRem(140)};

  h3 {
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: ${toRem(16)};
    font-weight: 700;
    line-height: ${toRem(24)};
  }

  p {
    color: var(--fg-soft, rgba(16, 24, 40, 0.75));
    font-size: ${toRem(14)};
    font-weight: 400;
    line-height: ${toRem(20)};
    display: flex;
    align-items: center;
    gap: 0;

    svg {
      width: ${toRem(24)};
      height: ${toRem(24)};
    }
  }
`;

export const PesticideMapImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${toRem(16)};
`;

export const StatesTitleRow = styled.div`
  margin: ${toRem(16)} ${toRem(16)} ${toRem(32)};
  display: flex;
  align-items: center;
  gap: ${toRem(8)};

  h3 {
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: ${toRem(16)};
    font-weight: 700;
    line-height: ${toRem(24)};
  }
`;

export const StatesCardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: ${toRem(72)} ${toRem(72)};
  gap: ${toRem(8)};
  flex-wrap: wrap;
  margin-top: ${toRem(32)};
  padding: 0 ${toRem(16)} ${toRem(16)} ${toRem(16)};

  @media screen and (max-width: ${toEm(1000)}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const StatesCard = styled.div`
  border-radius: ${toRem(16)};
  background: ${COLORS.BG.SURFACE3};
  display: flex;
  gap: ${toRem(12)};
  align-items: center;
  padding: ${toRem(16)};

  svg {
    width: ${toRem(24)};
    height: ${toRem(24)};
  }
`;

export const StatesCardCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;

  h4 {
    color: var(--fg-default, rgba(16, 24, 40, 1));
    font-size: ${toRem(20)};
    font-weight: 700;
    line-height: ${toRem(24)};
  }

  p {
    color: var(--fg-muted, rgba(16, 24, 40, 0.55));
    font-size: ${toRem(12)};
    font-weight: 400;
    line-height: ${toRem(16)};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-self: center;
  grid-area: archive;
  gap: 30px;
  margin-x: auto;
  &:hover {
    color: ${COLORS.ACCENT.HOVER};
  }

  @media screen and (max-width: ${toEm(1000)}) {
    margin-bottom: ${toRem(18)};
  }
`;
export const ArchiveApiaryButton = styled.button`
  color: ${COLORS.ACCENT.DEFAULT};
  font-size: ${toRem(16)};
  grid-area: archive;
  font-weight: 500;
  line-height: ${toRem(24)};
  text-align: center;
  width: max-content;
  justify-self: center;
  transition: color 0.3s ease-in-out;
  margin: 0 auto;

  &:hover {
    color: ${COLORS.ACCENT.HOVER};
  }

  @media screen and (max-width: ${toEm(1000)}) {
    margin-bottom: ${toRem(18)};
  }
`;
export const EditApiaryButton = styled.button`
  color: ${COLORS.ACCENT.DEFAULT};
  font-size: ${toRem(16)};
  grid-area: archive;
  font-weight: 500;
  line-height: ${toRem(24)};
  text-align: center;
  width: max-content;
  justify-self: center;
  transition: color 0.3s ease-in-out;
  margin: 0 auto;

  &:hover {
    color: ${COLORS.ACCENT.HOVER};
  }

  @media screen and (max-width: ${toEm(1000)}) {
    margin-bottom: ${toRem(18)};
  }
`;
